export default "__VITE_ASSET__BKtKoWdK__"